(function () {
    'use strict';

    angular.module('app')
        .service('AiService', AiService);

    AiService.$inject = ['$http'];

    function AiService($http) {
        this.processTiptap = function (prompt, text) {
            var data = $.param({
                prompt: prompt,
                text: text
            });
            return $http.post('/backend/altcrm/ai/tiptap', data).then(function (response) {
                return response.data;
            });
        };
    }
})();
